import React from 'react';
import SearchHouseBank from './searchGlCode';
import './index.scss';
const HouseBank = () => {
    
    return(<SearchHouseBank/>)
}

export default HouseBank;